<template>
  <!-- 課輔媒合 歷史紀錄 -->
  <div>
    <template v-if="!loadingFlag">
      <template v-if="historyList.length === 0">
        <div class="page-empty">
          <img src="../../../images/background-img/study-grey.png" alt />
          <h3>目前尚無歷史紀錄</h3>
        </div>
      </template>
    </template>
    <!-- 有資料時 -->
    <section class="list media-list">
      <div class="block-header">申請中</div>
      <ul>
        <li v-for="(item,index) in historyList" v-if="itekm.applyStatus === 10" >
          <div class="item-content">
            <div 
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
              ></div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{ item.chinese }}</div>
                </div>
                <div class="item-subtitle">{{ item.courseName }}</div>
              </div>
          </div>
        </li>
      </ul>
      <!--
      <ul>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">陳東東</div>
              </div>
              <div class="item-subtitle">基礎電機學</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/51.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">蔡娟娟</div>
              </div>
              <div class="item-subtitle">基礎電機學</div>
            </div>
          </div>
        </li>
      </ul>
      -->
    </section>

    <section class="list media-list">
      <div class="block-header">課輔中</div>
      <ul>
        <li v-for="(item,index) in historyList" v-if="item.applyStatus === 30" >
          <div class="item-content">
            <div 
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
              ></div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{ item.chinese }}</div>
                </div>
                <div class="item-subtitle">{{ item.courseName }}</div>
              </div>
          </div>
        </li>
      </ul>
      <!--
      <ul>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">陳東東</div>
              </div>
              <div class="item-subtitle">基礎電機學</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/51.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">蔡娟娟</div>
              </div>
              <div class="item-subtitle">基礎電機學</div>
            </div>
          </div>
        </li>
      </ul>
      -->
    </section>

    <section class="list media-list">
      <div class="block-header">完成課輔</div>
      <ul>
        <li v-for="(item,index) in historyList" v-if="item.applyStatus === 60" >
          <div class="item-content">
            <div 
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
              ></div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{ item.chinese }}</div>
                </div>
                <div class="item-subtitle">{{ item.courseName }}</div>
              </div>
          </div>
        </li>
      </ul>
      <!--
      <ul>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/90.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">王大明</div>
                <div class="item-after dollar">+ 1,000 Ｔ</div>
              </div>
              <div class="item-subtitle">微積分</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/90.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">王大明</div>
                <div class="item-after dollar">+ 1,000 Ｔ</div>
              </div>
              <div class="item-subtitle">微積分</div>
            </div>
          </div>
        </li>
      </ul>
      -->
    </section>
    <section class="list media-list">
      <div class="block-header">拒絕申請</div>
      <ul>
        <li v-for="(item,index) in historyList" v-if="item.applyStatus === 60" >
          <div class="item-content">
            <div 
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
              ></div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{ item.chinese }}</div>
                </div>
                <div class="item-subtitle">{{ item.courseName }}</div>
              </div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import Service from "../../../service";

import { bus } from '../../../js/bus';
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      historyList:[],
      loadingFlag : false
    };
  },
  created() {
    let self = this;
    bus.$on('historyBus',function(res){
      self.loadingFlag = true;
      self.historyList = res.historyList;
      self.loadingFlag = false;
    });

  },
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling/history-record.vue